import { useModuleBEM } from "@b2bportal/core-themes";
import type { SortOptionEnum } from "@b2bportal/core-types";
import { useSort } from "@tenant/flights";
import { RadioGroup } from "@tenant/ui";
import styles from "./FilterListSort.module.scss";

type FilterListSortProps = {
  selectedSort: SortOptionEnum;
  onChange: (value: SortOptionEnum) => void;
};

export const FilterListSort = ({
  selectedSort,
  onChange,
}: FilterListSortProps) => {
  const [block, cn] = useModuleBEM(styles, "FilterListSort");

  const {
    context: { sortOptions },
  } = useSort();

  return (
    <div className={block}>
      <RadioGroup
        className={cn("radio-group")}
        selectedOption={selectedSort}
        onSelectValue={onChange}
        options={sortOptions}
      />
    </div>
  );
};
